module.exports = __webpack_public_path__ + "static/media/Sandhaven.a3e97f67.png";